// extracted by mini-css-extract-plugin
module.exports = {"onlyTextContainer":"AgencyTeamTextOnlySlider_onlyTextContainer__x0jr4"};